import request from '@/router/axios'
import env from '@/config/env'
// 获取用户今日数据
export const getTodayUserData = () => {
  return request({
    url: env.ferryUrl + '/data-analysis/user-base',
    method: 'GET'
  })
}
// 获取下单页面访问漏斗
export const getOrderPage = (params) => {
  return request({
    url: env.ferryUrl + '/data-analysis/order',
    method: 'GET',
    params
  })
}
// 获取页面访问top5
export const getVisitorTop5 = (params) => {
  return request({
    url: env.ferryUrl + '/data-analysis/page-visit-top5',
    method: 'GET',
    params
  })
}
// 获取搜索词
export const getSearchKey = (params) => {
  return request({
    url: env.ferryUrl + '/data-analysis/searchKey-top10',
    method: 'GET',
    params
  })
}
// 获取icon pv、uv
export const getIconPU = (params) => {
  return request({
    url: env.ferryUrl + '/data-analysis/icon-pv-uv',
    method: 'GET',
    params
  })
}
// 获取某月页面浏览信息
export const getMonthVisit = (params) => {
  return request({
    url: env.ferryUrl + '/data-analysis/page-visit-info/one-month',
    method: 'GET',
    params
  })
}
